/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Track_Process_Nrl1Inputs */

const en_coinvestments_track_process_nrl1 = /** @type {(inputs: Coinvestments_Track_Process_Nrl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NRL`)
};

/**
* | output |
* | --- |
* | "NRL" |
*
* @param {Coinvestments_Track_Process_Nrl1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_track_process_nrl1 = /** @type {((inputs?: Coinvestments_Track_Process_Nrl1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Track_Process_Nrl1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_track_process_nrl1(inputs)
});
export { coinvestments_track_process_nrl1 as "coInvestments_track_process_nrl" }